import { ConditionBindingMinimal, RoundingConditionDTO } from '../../dtos';
import { PriceRoundingBrand } from '@retail/rounding/types';
import { dateFromString } from '@retail/utils';

interface RoundingRuleProps {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  ruleSetId: number;
  ruleSetName: string;
  centralOwner?: PriceRoundingBrand;
  validFrom: Date;
  validTo?: Date;
}

export class RoundingRuleCondition {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  ruleSetId: number;
  ruleSetName: string;
  centralOwner?: PriceRoundingBrand;
  validFrom: Date;
  validTo?: Date;

  constructor({
    conditionId,
    isInherited,
    inheritedBinding,
    isDeletionCondition,
    ruleSetId,
    ruleSetName,
    centralOwner,
    validFrom,
    validTo,
  }: RoundingRuleProps) {
    this.conditionId = conditionId;
    this.isInherited = isInherited;
    this.inheritedBinding = inheritedBinding;
    this.isDeletionCondition = isDeletionCondition;
    this.ruleSetId = ruleSetId;
    this.ruleSetName = ruleSetName;
    this.centralOwner = centralOwner;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  static fromDto = (
    dto: RoundingConditionDTO,
    selectedBrand: PriceRoundingBrand
  ): RoundingRuleCondition =>
    new RoundingRuleCondition({
      conditionId: dto.conditionId,
      isInherited: dto.isInherited,
      inheritedBinding: dto.inheritedBinding,
      isDeletionCondition: dto.isDeletionCondition,
      ruleSetId: dto.ruleSetId,
      ruleSetName: dto.ruleSetName,
      centralOwner: dto.ruleSetType === 'BRAND' ? selectedBrand : undefined,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
    });
}
